module.exports = __webpack_public_path__ + "svg/aws.792a65.svg";